export default __webpack_public_path__ + "static/media/1128040325514641.03874a53.jpg";